/** Google Map Api */
export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  let loadedApis = {};

  const loadApi = (params) => {
    const apiConfig = (window.aggMapConfig || {}).api || {};

    params = Object.assign({}, apiConfig, params);

    params.language = params.language || 'en';
    if (typeof params.libraries === 'string') {
      params.libraries = [params.libraries];
    }
    else if (!Array.isArray(params.libraries)) {
      params.libraries = ['places'];
    }

    params.libraries = encodeURIComponent(params.libraries.join(','));
    const apiUrl = `https://maps.googleapis.com/maps/api/js?key=${params.key}&libraries=${params.libraries}&language=${params.language}`;

    if (loadedApis[apiUrl] !== undefined) {
      return loadedApis[apiUrl];
    }

    loadedApis[apiUrl] = new Promise((resolve, reject) => {
      var s = window.document.createElement('script');

      s.src = apiUrl;
      s.defer = true;
      s.type = 'text/javascript';

      s.onload = () => {
        resolve(window.google.maps);
      };

      s.onerror = () => {
        // eslint-disable-next-line no-console
        console.error('Error loading Google Map Api: ', apiUrl);
      };

      window.document.body.appendChild(s);
    });

    return loadedApis[apiUrl];
  };

  return {
    loadApi
  };
})(jQuery, window);